import { roundValue } from "lib/number";
import { MetricsKind } from "../types";
import { MergedColumnFormulaOptions } from "./types";
import { ValueGetterParams } from "ag-grid-community";
import { ColumnTypes } from "components/product-collection/product-collection-views/product-collection-grid-view/product-collection-grid-view-helper";
import { referenceMetricValueOrCompute } from "../sibling-value-getter";
import { getChildrenUnits, getGrandTotalUnit } from "./units";

export const UNIT_DOOR_PERCENTAGE_PLAN = (
    _values: number[],
    options: MergedColumnFormulaOptions,
    gridGetterParams: ValueGetterParams
) => {
    const unitValue = referenceMetricValueOrCompute(
        () => getChildrenUnits(options, gridGetterParams),
        gridGetterParams,
        MetricsKind.UNITS
    );

    // Bail out sooner. No point doing heavy calculation of the whole rows if current value is 0.
    if (!unitValue) {
        return 0;
    }

    // For grand total, this will always be 100
    if (unitValue > 0 && gridGetterParams.column.getColDef().type === ColumnTypes.AllDimensionTotal) {
        return 100;
    }

    // Get aggregrated total units of a node group across all deliveries and groups
    const totalUnits = getGrandTotalUnit(options, gridGetterParams);

    return totalUnits > 0 ? roundValue((unitValue / totalUnits) * 100, options.decimal) : 0;
};
